import { css } from "lit";

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: block;
		position: relative;
		overflow: hidden;
		width: 100%;
		height: 100%;
	}

	.container {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	/* layout of the toolbar is done via inline styles in the template — the
	   element may be moved into an external title container outside this
	   shadow root (initToolbar), where these rules would not apply */
	.toolbar {
		border-bottom: 1px solid var(--og-bucket-border-color);
		background-color: var(--og-background-color-2);
		height: 28px;
	}

	og-toolbar {
		position: relative;
		height: 100%;
	}

	.body {
		flex: 1;
		position: relative;
		overflow: hidden;
	}

	canvas {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		z-index: 10000;
	}
`;
